<template>
  <div id="detail" style="">
    <div class="top">
      <img
        class="returns"
        src="@/assets/img/backleftarrow.png"
        alt=""
        @click="back()"
      />
    </div>
    <van-popup v-model="datePickerShow1" :style="{ width: '80%' }">
      <van-datetime-picker
        v-model="qrDate1"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="confirmDate('qrDate1', 'datePickerShow1')"
        @cancel="cancelDate('qrDate1', 'datePickerShow1')"
      />
    </van-popup>

    <div class="mid">
      <div class="header-card">
        <div class="strategy-header">
          <div class="strategy-title">
            <h2>{{ strategyinfo.name }}</h2>
            <div class="subscription-info">
              订阅人数: {{ strategyinfo.subscribers || 3607 }}
            </div>
          </div>
          <div class="action-button">
            <van-button
              round
              type="primary"
              size="small"
              :disabled="strategyinfo.subscribeStatus"
              @click="subscribeStrategy()"
              >{{ strategyinfo.subscribeStatus ? '已订阅' : '订阅' }}</van-button
            >
          </div>
        </div>
      </div>

      <div class="notice-bar-wrap" v-show="false">
        <van-swipe
          class="notice-bar-swipe"
          :loop="true"
          :touchable="false"
          vertical
          :height="130"
          :autoplay="5000"
          :show-indicators="false"
        >
          <van-swipe-item
            v-for="(item, index) in strategyinfo.broadcasts"
            :key="index"
          >
            <div class="notice-bar">
              <img src="@/assets/img/notice.png" alt="" class="notice-icon" />
              <div class="text">
                {{ item }}
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>

      <div class="section-title single">自我介绍</div>

      <div
        class="user-introduce markdown-content"
        v-html="renderedIntroduction"
      ></div>

      <div class="section-title single">说给你听</div>

      <div
        class="user-introduce markdown-content tell-you-content"
        :class="{ 'line-clamp-3': !isExpanded }"
        v-html="renderedTellYou"
        ref="contentDiv"
      ></div>
      <div class="expand-all" v-if="hasOverflow" @click="toggleExpand">
        {{ isExpanded ? "收起" : "展开全部" }}
        <img
          src="@/assets/img/drop.png"
          alt=""
          class="dropdown-icon"
          :class="{ 'rotate-icon': isExpanded }"
        />
      </div>

      <div class="performance-metrics">
        <div class="metric-item">
          <div class="metric-label">年化收益</div>
          <div class="metric-value">{{ strategyinfo.annualizedReturn }}</div>
        </div>
        <div class="metric-item">
          <div class="metric-label">累计收益</div>
          <div class="metric-value">{{ strategyinfo.totalReturn }}</div>
        </div>
        <div class="metric-item">
          <div class="metric-label">最大回撤</div>
          <div class="metric-value">{{ strategyinfo.maximumDrawdown }}</div>
        </div>
        <div class="metric-item">
          <div class="metric-label">风险类型</div>
          <div class="metric-value">{{ getRiskType(strategyinfo) }}</div>
        </div>
      </div>

      <div class="chart-section">
        <div class="chart-title-bar">
          <div class="section-title">业绩曲线</div>
        </div>
        <div class="chart-container echart-container">
          <div class="chart-button">
            <div
              @click="handleChartChange(item.value)"
              :class="[
                {
                  'chart-button-item': true,
                  'active-button': activeTime === item.value,
                },
              ]"
              v-for="item in buttons"
              :key="item.text"
            >
              {{ item.text }}
            </div>
          </div>
          <div
            id="pig"
            class="line"
            :style="{ width: cubeWidth, height: '240px' }"
          />
        </div>
      </div>

      <div
        class="chart-section swiper"
        v-if="
          strategyinfo &&
            strategyinfo.picList &&
            strategyinfo.picList.length > 0
        "
      >
        <div class="chart-title-bar">
          <div class="section-title">实盘截图</div>
          <div class="section-subtitle">周度更新</div>
        </div>
        <div class="chart-container">
          <van-swipe
            :loop="false"
            :show-indicators="false"
            :width="158"
            :height="156"
          >
            <van-swipe-item
              v-for="(item, index) in strategyinfo.picList"
              :key="index"
            >
              <div class="image-contain">
                <img
                  class="image-inner"
                  :src="item.thumbUrl || item.url"
                  loading="lazy"
                  alt=""
                  @click="previewImage(index)"
                />
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>

      <!-- AI实况模块 -->
      <div
        class="chart-section swiper ai-dynamic"
        v-if="aiLiveList && aiLiveList.length > 0"
      >
        <div class="chart-title-bar">
          <div class="section-title single ai-dynamic-title">AI实况</div>
          <div class="ai-live-date">
            <div class="current-date">
              更新于{{ `${aiLiveList.at(-1).date} ${aiLiveList.at(-1).time}` }}
            </div>
          </div>
        </div>
      </div>

      <div class="ai-live-section" ref="aiLiveScrollWrap">
        <div class="ai-live-list" ref="aiLiveList">
          <div
            class="ai-live-item"
            v-for="(item, index) in displayedAiLiveItems"
            :key="index"
          >
            <div class="ai-live-time-column">
              <div class="ai-date">{{ item.date }}</div>
              <div class="ai-time">{{ `${item.time}` }}</div>
            </div>
            <div class="ai-live-content">
              <div class="ai-live-title">{{ item.title }}</div>
              <div
                class="ai-live-desc"
                ref="aiLiveDesc"
                :class="{
                  expanded: !item.hasMore,
                  'no-ellipsis': !item.isOverflow,
                }"
                @click="showMoreContent(item)"
                v-html="transToHtml(item.fullContent)"
              />
              <!-- 收起按钮 -->
              <div
                v-if="!item.hasMore"
                class="collapse-button"
                @click="showMoreContent(item)"
              >
                收起
                <img
                  src="@/assets/img/drop.png"
                  alt=""
                  class="dropdown-icon rotate-icon"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- <div
          class="expand-all"
          @click="toggleAiLiveList"
          v-if="shouldShowExpandButton"
        >
          {{ showAllAiLive ? "收起" : "展开全部" }}
          <img
            src="@/assets/img/drop.png"
            alt=""
            class="dropdown-icon"
            :class="{ 'rotate-icon': showAllAiLive }"
          />
        </div> -->
      </div>

      <div class="section-title single">交易日志</div>
      <div class="transaction-section">
        <div class="tab-buttons">
          <div
            class="tab-button"
            :class="{ active: activeTab === 'all' }"
            @click="switchTab('all')"
          >
            全部
          </div>
          <div
            class="tab-button"
            :class="{ active: activeTab === 'milestone' }"
            @click="switchTab('milestone')"
          >
            里程碑
          </div>
        </div>

        <div class="date-range-picker" v-if="activeTab === 'all'">
          <div class="date-input" @click="openDatePicker">
            <span>{{ formatDate(qrDate1) }}</span>
            <img src="@/assets/img/drop.png" alt="" class="dropdown-icon" />
          </div>
          <span class="date-separator">至</span>
          <div class="date-input">
            <span>{{ formatDate(qrDate2) }}</span>
          </div>
        </div>

        <div class="section-desc">
          <div class="desc-title">交易总结</div>
          <div
            class="desc-content"
            :class="{ expanded: tradeContentExpanded }"
            @click="toggleTradeContent"
            v-html="transToHtml(tradeContent)"
          />
          <div
            class="expand-trade"
            v-if="tradeContent && tradeContent.length > 100"
            @click="toggleTradeContent"
          >
            {{ tradeContentExpanded ? "收起" : "展开" }}
            <img
              src="@/assets/img/drop.png"
              alt=""
              class="dropdown-icon"
              :class="{ 'rotate-icon': tradeContentExpanded }"
            />
          </div>
        </div>

        <div class="transaction-list">
          <div
            class="transaction-item"
            v-for="(item, index) in recordList"
            :key="index"
          >
            <span class="transaction-date">{{ item.date }}</span
            ><span
              :class="
                item.type === '买入' ? 'transaction-buy' : 'transaction-sell'
              "
              >{{ item.type }}:</span
            ><span>{{ item.ticker }}</span>
            <span v-if="item.type === '卖出'">卖价: {{ item.sellPrice }}</span>
            <span v-if="item.type === '卖出'">{{ item.buyDate }}</span>
            <span v-if="item.type === '卖出'" class="transaction-buy"
              >买入</span
            >
            <span>买价: {{ item.buyPrice }}</span>
            <span v-if="item.type === '卖出'"
              >收益率:
              <span
                :class="
                  isPositivePercent(item.returnRate)
                    ? 'positive-rate'
                    : 'negative-rate'
                "
                >{{ item.returnRate }}</span
              ></span
            >
          </div>
        </div>
      </div>
      <icp-info />
    </div>
    <div class="bottom">
      <the-tabbar active-page="teacher" />
    </div>
    <!-- 策略订阅邀请码弹窗 -->
    <invite-code-popup 
      v-model="inviteCodeDialogVisible" 
      @submit="onInviteCodeSubmit" 
      @contact="onContactCustomerService" 
    />
    <!-- 状态弹窗 -->
    <status-popup
      v-model="statusPopupVisible"
      :type="statusPopupType"
      :title="statusPopupTitle"
      :description="statusPopupDescription"
      :auto-close-delay="autoCloseDelay"
      :confirm-text="statusPopupConfirmText"
      :cancel-text="statusPopupCancelText"
      :show-cancel-button="statusPopupShowCancelButton"
      :show-confirm-button="statusPopupShowConfirmButton"
      @confirm="onStatusPopupConfirm"
      @cancel="onStatusPopupClose"
      @close="onStatusPopupClose"
    />
    <!-- 统一弹窗 -->
    <subscribe-prompt-popup v-model="showPrompt" @contact="onPromptContact" @purchase="onPromptPurchase" />
  </div>
</template>
<script>
import Vue from "vue";
import TheTabbar from "@/components/theTabbar.vue";
import IcpInfo from "@/components/IcpInfo.vue";
import {
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Button,
  Card,
  Tag,
  Cell,
  Toast,
  Tab,
  Tabs,
  Collapse,
  CollapseItem,
  DatetimePicker,
  Popup,
  Dialog,
  Field,
} from "vant";
import ImagePreview from "vant/lib/image-preview";
import "vant/lib/image-preview/style";
import echarts from "echarts";
import MarkdownIt from "markdown-it";
import {
  fetchStrategyV2,
  fetchUserSubscribeStrategy,
  fetchStrategy,
  islogin,
  fetchHistory,
  fetchTradeRecordInDetailV2,
  fetchWarehouseHistory,
  isvipApi,
} from "@/api/theApi";
import StatusPopup from "@/components/StatusPopup.vue";
import InviteCodePopup from "@/components/InviteCodePopup.vue";
import SubscribePromptPopup from "@/components/SubscribePromptPopup.vue";
import { openUseasyWebChat } from "@/utils/useasyKeFu";
Vue.use(Toast);
export default {
  components: {
    StatusPopup,
    InviteCodePopup,
    SubscribePromptPopup,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton,
    [Button.name]: Button,
    [Card.name]: Card,
    [Tag.name]: Tag,
    [Cell.name]: Cell,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field,
    TheTabbar,
    IcpInfo,
  },
  data() {
    return {
      strategyId: "",
      classId: "",
      chart: "",
      strategyinfo: {},
      history: [],
      warehouse: [],
      active: 2,
      activeNames: ["1"],
      activeNames2: ["1"],
      qrDate1: (function() {
        const selectedDate = new Date(); // 获取当前日期
        // const day = today.getDay(); // 获取当前是周几，0（周日）到6（周六）
        // const diff = today.getDate() - day + (day >= 1 ? -7 : -6); // 计算距离上周周一的天数差
        // const lastMonday = new Date(today); // 复制当前日期
        // lastMonday.setUTCDate(diff); // 设置日期为上周周一
        // lastMonday.setHours(0, 0, 0);
        // return lastMonday;\
        const dayOfWeek = selectedDate.getDay();
        let monday = new Date(selectedDate);
        if (dayOfWeek !== 1) {
          const diff = (dayOfWeek + 6) % 7;
          monday.setDate(selectedDate.getDate() - diff);
          return new Date(monday);
        } else {
          monday.setDate(selectedDate.getDate() - 7);
          return new Date(monday);
        }
        return selectedDate;
      })(),
      //   qrDate2: new Date(),
      minDate: new Date("2000", "01", "01"),
      maxDate: new Date(),
      datePickerShow1: false,
      isvip: false,
      exptime: "",
      islogin: false,
      activeTab: "all", // 添加activeTab状态变量，默认显示全部标签
      recordList: [],
      tradeContent: "",
      buttons: [
        { text: "近3个月", value: 3 },
        { text: "近6个月", value: 2 },
        { text: "近1年", value: 1 },
        { text: "近3年", value: 5 },
        { text: "全部", value: 9 },
      ],
      activeTime: 3,
      // AI实况相关数据
      aiLiveList: [],
      showAllAiLive: false,
      tradeContentExpanded: false, // 交易总结展开状态
      isExpanded: false, // 展开状态
      isDestroyed: false, // 添加组件销毁状态标记
      statusPopupVisible: false,
      statusPopupType: "success",
      statusPopupTitle: "",
      statusPopupDescription: "",
      statusPopupConfirmText: "去关联",
      statusPopupCancelText: "以后再说",
      statusPopupShowCancelButton: false,
      statusPopupShowConfirmButton: false,
      autoCloseDelay: 3000,
      assignUrl: "",
      inviteCodeDialogVisible: false,
      showPrompt: false,
      inviteCodeInput: "",
    };
  },
  computed: {
    cubeWidth: () => {
      return document.body.clientWidth;
    },
    cubeHeight: () => {
      return document.body.clientHeight;
    },
    devicePixelRatio: () => {
      return window.devicePixelRatio;
    },
    displayedAiLiveItems() {
      //   if (this.showAllAiLive || this.aiLiveList.length <= 3) {
      this.$nextTick(() => {
        this.$refs.aiLiveScrollWrap.scrollTo(
          0,
          this.$refs.aiLiveList.clientHeight
        );
      });
      return this.aiLiveList;
      //   } else {
      //     return this.aiLiveList.slice(0, 3);
      //   }
    },
    shouldShowExpandButton() {
      return this.aiLiveList.length > 3;
    },
    renderedTellYou() {
      if (!this.strategyinfo.tellYou) return "";
      const md = new MarkdownIt({
        html: true,
        linkify: true,
        typographer: true,
        breaks: true,
      });
      return md.render(this.strategyinfo.tellYou);
    },
    renderedIntroduction() {
      if (!this.strategyinfo.introduction) return "";
      const md = new MarkdownIt({
        html: true,
        linkify: true,
        typographer: true,
        breaks: true,
      });
      return md.render(this.strategyinfo.introduction);
    },
    login_status: () => {
      const islogin = localStorage.getItem("login_status");

      if (islogin === "true") {
        return true;
      } else {
        return false;
      }
    },
    qrDate2() {
      const today = new Date(this.qrDate1.getTime());
      // 2. 计算当前日期是周几
      const dayOfWeek = today.getDay();

      // 3. 计算到本周日还有多少天
      let daysUntilSunday;
      if (dayOfWeek === 0) {
        // 如果今天是周日，则本周日就是今天
        daysUntilSunday = 0;
      } else {
        // 否则，计算到下一个周日的天数
        daysUntilSunday = 7 - dayOfWeek;
      }

      // 4. 根据天数计算出本周日的日期
      const sunday = new Date(today);
      sunday.setDate(today.getDate() + daysUntilSunday);
      const nowDate = new Date();
      return sunday > nowDate ? nowDate : sunday;
    },
    hasOverflow() {
      return (this.strategyinfo.tellYou || "").length >= 120;
    },
  },
  async created() {
    try {
      await this.initData();

      // 检查组件是否已销毁
      if (this.isDestroyed) return;

      await this.initEchartsData();

      // 检查组件是否已销毁
      if (this.isDestroyed) return;

      // 检查组件是否已销毁
      if (this.isDestroyed) return;

      // 不管是否匹配都获取历史数据，以便显示预览
      this.fetchHistory();
      this.fetchWarehouseHistory();
    } catch (error) {
      console.error("组件初始化失败:", error);
    }
  },
  mounted() {
    console.log("mounted::isvip", this.isvip);
    console.log("mounted::islogin", this.islogin);
  },
  updated() {},
  beforeDestroy() {
    // 设置组件销毁标记
    this.isDestroyed = true;

    // 清理echarts实例
    if (this.chart) {
      try {
        this.chart.dispose();
        this.chart = null;
      } catch (error) {
        console.error("销毁图表失败:", error);
      }
    }

    // 清理可能存在的自定义DOM元素
    const remarkEl = document.getElementById("custom-image-remark");
    if (remarkEl && remarkEl.parentNode) {
      remarkEl.parentNode.removeChild(remarkEl);
    }
  },
  methods: {
    getRiskType(item) {
      const risk = item && (item.riskType || item.risk_type);
      return risk ? String(risk).trim() : '';
    },
    reg() {
      this.$router.push({
        path: "/regLogin",
      });
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    isPositivePercent(percentStr) {
      if (!percentStr) return false;
      const numValue = parseFloat(percentStr.replace("%", ""));
      return !isNaN(numValue) && numValue > 0;
    },
    back() {
      // 检查是否有足够的历史记录可以回退
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        // 如果没有历史记录可回退，则跳转到用户页面
        this.$router.replace("/strategylist");
      }
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}/${month}/${day}`;
    },
    async isloginFun() {
      const vm = this;
      const isloginRes = await islogin();
      if (!isloginRes.login_status) {
        this.islogin = false;
      } else {
        this.islogin = true;
      }
    },
    handleChartChange(value) {
      // 检查组件是否已销毁
      if (this.isDestroyed) {
        return;
      }

      this.activeTime = value;
      this.initEchartsData();
    },
    async initEchartsData() {
      // 检查组件是否已销毁
      if (this.isDestroyed) {
        return;
      }

      this.strategyId = await this.$route.params.id;
      const res1 = await fetchStrategy(this.strategyId, this.activeTime, 1);

      // 再次检查组件是否已销毁
      if (this.isDestroyed) {
        return;
      }

      const exptime = localStorage.getItem("exptime");
      this.exptime = exptime;
      // res1.data.forEach((item) => {
      //   item.market = item.market*100;
      //   item.predict_strategy_value = item.predict_strategy_value*100;
      // })
      this.drawChart(res1.data);
    },
    async isvipFun() {
      const username = localStorage.getItem("username");
      if (username) {
        const rslt = await isvipApi(username);
        if (rslt.data.isvip === "1") {
          console.log("vip", rslt.data.isvip);
          this.isvip = true;
        } else {
          this.isvip = false;
        }
      }
    },
    // 成为vip
    vip() {
      // 检验是否可以进入支付流程

      //
      this.$router.push({
        path: "/pay",
      });
    },
    confirmDate: async function(timeType, showType) {
      this[showType] = false;

      const selectedDate = new Date(this.qrDate1);
      const dayOfWeek = selectedDate.getDay();
      if (dayOfWeek !== 1) {
        const diff = (dayOfWeek + 6) % 7;
        const monday = new Date(selectedDate);
        monday.setDate(selectedDate.getDate() - diff);
        this.qrDate1 = new Date(monday);
      }
      await this.fetchTradeRecord(this.activeTab);
    },
    cancelDate: function(timeType, showType) {
      // this[timeType] = new Date();
      this[showType] = false;
    },
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      } else if (type === "day") {
        return `${value}日`;
      }
      return value;
    },
    dateOfDatetime(datetime) {
      const theDatetime = new Date(datetime);
      const year = theDatetime.getFullYear() + "-";
      const month = theDatetime.getMonth() + 1 + "-";
      const date = theDatetime.getDate();
      return year + month + date;
    },
    theislogin() {
      islogin().then((res) => {
        if (res.login_status) {
          return true;
        } else {
          return false;
        }
      });
    },
    async initData() {
      // 检查组件是否已销毁
      if (this.isDestroyed) {
        return;
      }

      this.strategyId = await this.$route.params.id;
      const res1 = await fetchStrategyV2(
        this.strategyId,
        localStorage.getItem("username")
      );

      if (!res1 || res1.code !== 20000 || !res1.data) {
        Toast.fail((res1 && res1.msg) || '暂无权限访问该详情');
        setTimeout(() => {
          this.back();
        }, 1000);
        return;
      }

      // 检查组件是否已销毁
      if (this.isDestroyed) {
        return;
      }

      await this.fetchTradeRecord(this.activeTab);

      // 检查组件是否已销毁
      if (this.isDestroyed) {
        return;
      }

      const StrategyInfo = res1.data;
      this.strategyinfo = StrategyInfo;
      this.aiLiveList = (StrategyInfo.broadcasts || []).map((f) => ({
        ...f,
        date: f.time.split(" ")[0],
        time: f.time.split(" ")[1],
        // time: f.time.split(" ").length>1?f.time.split(" ")[1]:'', //不带天的
        fullContent: f.content,
        hasMore: true,
        isOverflow: true,
      }));
      this.checkAiLiveOverflow();
    },
    // 收起态下实际未被截断的条目不应显示“更多”
    checkAiLiveOverflow() {
      this.$nextTick(() => {
        if (this.isDestroyed) {
          return;
        }
        const refs = this.$refs.aiLiveDesc;
        if (!refs) {
          return;
        }
        const els = Array.isArray(refs) ? refs : [refs];
        els.forEach((el, index) => {
          const item = this.aiLiveList[index];
          if (!el || !item) {
            return;
          }
          item.isOverflow = el.scrollHeight - el.clientHeight > 1;
        });
      });
    },
    init() {
      // 页面初始化
      // 1. 通过路由获取当前投顾 id
      // let strategy_id = this.$route.query.id
    },
    drawChart(data) {
      // 检查组件是否已销毁
      if (this.isDestroyed) {
        return;
      }

      // 检查DOM元素是否存在
      const chartElement = document.getElementById("pig");
      if (!chartElement) {
        console.warn("图表容器元素不存在，跳过图表初始化");
        return;
      }

      // 如果图表已存在，先销毁
      if (this.chart) {
        try {
          this.chart.dispose();
          this.chart = null;
        } catch (error) {
          console.error("销毁旧图表失败:", error);
        }
      }

      try {
        this.chart = echarts.init(chartElement);
        this.chart.setOption({
          tooltip: {
            trigger: "axis",
            formatter: function(params) {
              let result = params[0].name + "<br/>";
              params.forEach((item) => {
                // 将小数转换为百分数格式，保留2位小数
                const value = (item.value).toFixed(2) + "%";
                const color = item.color;
                result += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${color};"></span>${item.seriesName}: ${value}<br/>`;
              });
              return result;
            },
          },
          legend: {
            data: ["投顾","中证500"],
          },
          grid: {
            left: 15,  // 原来默认是50，增加4px使图表右移
            containLabel: true
          },
          dataZoom: [
            {
              startValue: "",
            },
            {
              type: "inside",
            },
          ],
          xAxis: {
            // type: 'category',
            // boundaryGap: false,
            // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
            data: data.map((item) => {
              return item.as_of_date;
            }),
            spliteLine: {
              show: true,
              lineStyle: {
                color: ["grey"],
                width: 1,
                type: "solid",
              },
            },
          },
          yAxis: {
            name: "收益率（%）",
          },
          series: [
            {
              name: "中证500",
              type: "line",
              itemStyle: {
                color: "#1D2088",
              },
              data: data.map(function(item) {
                return item.market * 100;
              }),
              splitLine: {
                show: true,
                lineStyle: {
                  color: ["grey"],
                  width: 1,
                  type: "solid",
                },
              },
              // areaStyle: {
              // color: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
              // },
            },
            {
              name: "投顾",
              type: "line",
              itemStyle: {
                color: "#FF3600",
              },
              data: data.map(function(item) {
                return item.predict_strategy_value * 100;
              }),
              // areaStyle: {
              // color: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
              // },
            },
          ],
        });
      } catch (error) {
        console.error("初始化图表失败:", error);
      }
    },
    async copyStrategyName() {
      try {
        const strategyCode = this.strategyinfo.code;
        await navigator.clipboard.writeText(strategyCode);
        Toast.success("交易代码已复制");
      } catch (error) {
        console.error("复制失败:", error);
        Toast.fail("复制失败");
      }
    },
    switchTab(tab) {
      this.activeTab = tab;
      this.fetchTradeRecord(tab);
    },
    async fetchHistory() {
      // 检查组件是否已销毁
      if (this.isDestroyed) {
        return;
      }

      const rslt = await fetchHistory(
        this.$route.params.id,
        this.$route.params.cid
      );

      if (!this.isDestroyed) {
        this.history = rslt;
      }
    },
    async fetchWarehouseHistory() {
      // 检查组件是否已销毁
      if (this.isDestroyed) {
        return;
      }

      const rslt = await fetchWarehouseHistory(
        this.$route.params.id,
        this.$route.params.cid
      );

      if (!this.isDestroyed) {
        this.warehouse = rslt;
      }
    },
    formatDate2(date) {
      var year = date.getFullYear();
      var month = ("0" + (date.getMonth() + 1)).slice(-2);
      var day = ("0" + date.getDate()).slice(-2);
      return year + "-" + month + "-" + day;
    },
    async fetchTradeRecord(type) {
      // 检查组件是否已销毁
      if (this.isDestroyed) {
        return;
      }

      const res = await fetchTradeRecordInDetailV2(
        this.strategyId,
        localStorage.getItem("username"),
        type,
        this.formatDate2(this.qrDate1),
        this.formatDate2(this.qrDate2)
      );

      // 检查组件是否已销毁
      if (this.isDestroyed) {
        return;
      }

      const { data } = res || {};
      this.recordList = (data && data.list) || [];
      this.tradeContent = (data && data.content) || "";
    },
    previewImage(index) {
      const images = this.strategyinfo.picList.map((item) => item.url);
      const remarks = this.strategyinfo.picList.map((item) => item.remark);

      // 打开图片预览
      const instance = ImagePreview({
        images,
        startPosition: index,
        onChange(position) {
          updateRemark(remarks[position]);
        },
        onClose() {
          removeRemark();
        },
      });

      // 创建并插入 remark DOM
      function updateRemark(text) {
        let remarkEl = document.getElementById("custom-image-remark");
        if (!remarkEl) {
          remarkEl = document.createElement("div");
          remarkEl.id = "custom-image-remark";
          remarkEl.style.cssText =
            "position:fixed;bottom:0;left:0;right:0;width:100vw;box-sizing:border-box;text-align:left;color:#fff;font-size:14px;line-height:22px;height:auto;z-index:99999;padding:10px 8px; padding-bottom: calc(10px + env(safe-area-inset-bottom)); pointer-events:none;background:rgba(0,0,0,0.55)";
          document.body.appendChild(remarkEl);
        }
        remarkEl.innerText = text || "";
      }
      function removeRemark() {
        const remarkEl = document.getElementById("custom-image-remark");
        if (remarkEl) document.body.removeChild(remarkEl);
      }
      // 初始化
      updateRemark(remarks[index]);
    },
    showMoreContent(item) {
      // 切换展开/收起状态
      item.hasMore = !item.hasMore;
    },
    toggleAiLiveList() {
      this.showAllAiLive = !this.showAllAiLive;

      // 控制内容的展开状态
      if (!this.showAllAiLive) {
        // 收起时，重置所有项的 hasMore 状态
        this.aiLiveList.forEach((item) => {
          item.hasMore = true;
        });
      }
    },
    openDatePicker() {
      this.datePickerShow1 = true;
    },
    transToHtml(markdown) {
      if (!markdown) return "";
      const md = new MarkdownIt({
        html: true,
        linkify: true,
        typographer: true,
        breaks: true,
      });
      return md.render(markdown);
    },
    toggleTradeContent() {
      this.tradeContentExpanded = !this.tradeContentExpanded;
    },
    async subscribeStrategy() {
      // 登陆是否过期
      const theislogin = await islogin();
      if (!theislogin.login_status) {
        Toast.fail("请先登录");
        setTimeout(() => {
          this.$router.push({
            path: "/login",
          });
        }, 1000);
        return;
      }

      if (this.strategyinfo && this.strategyinfo.accessLevel === 1) {
        this.showPrompt = true;
        return;
      }

      if (this.strategyinfo && this.strategyinfo.needInviteCode) {
        this.inviteCodeDialogVisible = true;
      } else {
        this.doSubscribeStrategy("");
      }
    },
    onInviteCodeSubmit(code) {
      this.doSubscribeStrategy(code);
      this.inviteCodeDialogVisible = false;
    },
    onContactCustomerService() {
      openUseasyWebChat({
        imUrlTitle: "投顾详情",
        imFromUrl: `/strategy/detail/${this.strategyId}`
      });
    },
    onPromptContact() {
      this.showPrompt = false;
      this.onContactCustomerService();
    },
    onPromptPurchase() {
      this.showPrompt = false;
      this.$router.push('/subscription');
    },
    doSubscribeStrategy(inviteCode) {
      fetchUserSubscribeStrategy(
        this.strategyId,
        inviteCode
      ).then((res) => {
        if (res.code === 20000) {
          this.showSuccess();
          this.initData();
        } else if (res.code === 5001) {
          this.assignUrl = res.data;
          this.statusPopupDescription =
            "很抱歉，由于您当前未签约投顾无法享受订阅服务。快去签约投顾吧，将会跳转三方券商进行签约投顾。";

          this.showError();
        } else {
          Toast(res.msg || '订阅失败');
        }
      });
    },
    onStatusPopupClose() {
      this.statusPopupVisible = false;
    },
    // 显示成功弹窗
    showSuccess() {
      this.statusPopupType = "success";
      this.statusPopupTitle = "订阅成功";
      this.statusPopupDescription = `恭喜你已成功订阅${this.strategyinfo.name}老师的服务`;
      this.statusPopupConfirmText = "";
      this.statusPopupCancelText = "";
      this.statusPopupShowCancelButton = false;
      this.statusPopupShowConfirmButton = false;
      this.autoCloseDelay = 3000;
      this.statusPopupVisible = true;
    },

    // 显示失败弹窗
    showError() {
      this.statusPopupType = "error";
      this.statusPopupTitle = "订阅失败";
      this.statusPopupDescription =
        "很抱歉，由于您当前未签约投顾无法享受订阅服务。快去签约投顾吧，将会跳转三方券商进行签约投顾。";
      this.statusPopupShowCancelButton = true;
      this.statusPopupShowConfirmButton = true;
      this.statusPopupConfirmText = "去签约";
      this.statusPopupCancelText = "以后再说";
      this.statusPopupVisible = true;
      this.autoCloseDelay = 0;
    },

    onStatusPopupConfirm() {
      this.statusPopupVisible = false;
      if (this.assignUrl) {
        location.href = this.assignUrl;
      } 
    },
    getValidateInfo() {
      fetchUserIndentity().then((res) => {
        if (res.code === 20000) {
          this.validateInfo = res.data;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
#detail {
  background-color: #f5f5f5;
  padding-top: 16px;
  .top {
    .returns {
      display: block;
      width: 24px;
      height: 24px;
      margin: 16px;
      margin-top: 0;
    }
  }

  // 头部卡片样式
  .header-card {
    color: #000;
    margin-bottom: 12px;
  }

  .strategy-header {
    line-height: 1.5;
    display: flex;
    align-items: flex-start;
    margin-bottom: 16px;
  }

  .back-button {
    margin-right: 10px;
  }

  .strategy-title {
    flex: 1;

    h2 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
    }
  }

  .subscription-info {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
    margin-top: 4px;
  }

  .action-button {
    .van-button {
      width: 100px;
      height: 32px;
      background-color: #000;
      color: #fff;
      border: 1px solid #fff;
      font-size: 12px;
      padding: 0 12px;
    }
  }

  .performance-metrics {
    background: #fff;
    height: 74px;
    padding: 16px;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
  }

  .chart-title-bar {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .section-subtitle {
    color: #8e8e93;
    font-size: 14px;
    line-height: 1.5;
    margin-right: 16px;
  }

    .metric-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .metric-label {
        font-size: 14px;
        color: #8e8e93;
        line-height: 1.5;
        margin-bottom: 4px;
      }

      .metric-value {
        font-size: 20px;
        font-weight: 600;
      }
    }

  .card {
    margin: 12px 16px;
    padding: 16px;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  .card-title {
    margin-bottom: 12px;
    font-weight: 600;
  }

  .cardline {
    margin: 0 0 8px 10px;
  }

  .locked-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 0;
    color: #999;
    background-color: #f8f9fc;
    border-radius: 12px;
    margin: 16px;

    p {
      margin-top: 12px;
      font-size: 14px;
    }
  }

  .preview-content {
    margin-top: 20px;
    width: 100%;
    padding: 0 16px;

    .preview-title {
      color: #666;
      font-size: 14px;
      margin-bottom: 12px;
      text-align: left;
    }

    ::v-deep .van-collapse {
      background-color: transparent;
    }

    ::v-deep .van-collapse-item {
      margin-bottom: 12px;
      background-color: #f8f8f8;
      border-radius: 8px;
    }
  }

  // 自定义标签样式
  ::v-deep .van-tag {
    border-radius: 4px;
    padding: 4px 8px;
    margin-right: 8px;
    margin-bottom: 8px;

    &.van-tag--plain {
      background-color: rgba(255, 102, 0, 0.1);
      color: #ff6600;
      border-color: #ff6600;
    }
  }

  // 自定义标签页样式
  ::v-deep .van-tabs__line {
    background-color: #ff6600;
    height: 3px;
    border-radius: 3px;
  }

  ::v-deep .van-tabs__nav {
    padding: 0 16px;
  }

  ::v-deep .van-tab {
    font-size: 16px;
    font-weight: 500;
  }

  ::v-deep .van-tab--active {
    color: #ff6600;
    font-weight: 600;
  }

  // 图表部分样式
  .chart-section {
    margin: 24px 0;
  }

  .chart-section,
  .transaction-section,
  .performance-metrics,
  .header-card {
    margin: 0 16px;

    &.swiper {
      margin-right: 0;
    }
  }

  .section-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
    margin-top: 24px;
    line-height: 1.5;
    color: #333;
    position: relative;

    &.single {
      margin: 0 16px;
    }

    .section-info {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      background-color: #ccc;
      color: #fff;
      border-radius: 50%;
      font-size: 12px;
      margin-left: 4px;
      vertical-align: middle;
    }
  }

  .chart-container {
    display: flex;
    overflow-x: auto;
    padding-bottom: 8px;

    &.echart-container {
      padding: 8px 4px;
      border-radius: 8px;
      background: #ffffff;
      flex-direction: column;
      align-items: flex-start;
    }

    .chart-button {
      padding-left: 8px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      column-gap: 8px;
      margin-bottom: 8px;
      .chart-button-item {
        padding: 5px 10px;
        background: #0000000d;
        border-radius: 4px;
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 12px;
        line-height: 130%;
        letter-spacing: 0.67%;
        color: #0000007a;
        &.active-button {
          background: #000000;
          color: #ffffff;
        }
      }
    }
  }

  .line {
    border-radius: 8px;
    overflow: hidden;
    margin: 0;
    min-width: 100%;
  }

  // 底部操作栏样式
  ::v-deep .van-goods-action {
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
  }

  ::v-deep .van-goods-action-button--danger {
    background: linear-gradient(to right, #ff9900, #ff6600);
  }

  // 交易日志部分样式
  .transaction-section {
    background-color: #fff;
    margin: 12px 16px;
    padding: 16px;
    border-radius: 8px;
  }

  .tab-buttons {
    display: flex;
    margin-bottom: 16px;
    border-radius: 90px;
    overflow: hidden;
    background-color: #edeff3;
    padding: 3px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }

  .tab-button {
    flex: 1;
    text-align: center;
    padding: 10px 0;
    font-size: 12px;
    color: #878b91;
    font-weight: 500;
    border-radius: 90px;
    transition: all 0.3s ease;
    position: relative;
    cursor: pointer;

    &.active {
      background-color: #fff;
      color: #000000;
      font-weight: 600;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    }

    &:not(.active):hover {
      color: #000000;
      background-color: rgba(255, 255, 255, 0.5);
    }
  }

  .transaction-type {
    width: auto;
    font-size: 10px;
    padding: 2px 6px;

    &.buy {
      color: #f56c6c;
    }

    &.sell {
      color: #67c23a;
    }

    &.milestone {
      color: #409eff;
    }
  }

  .transaction-list {
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    row-gap: 16px;
  }

  .transaction-item {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    word-break: break-all;
    column-gap: 8px;

    span {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 12px;
      line-height: 150%;
      letter-spacing: 0px;
      color: #00000099;

      &.transaction-buy {
        color: #4899a4;
        font-weight: 500;
      }
      &.transaction-sell {
        color: #d68b49;
        font-weight: 500;
      }
      &.positive-rate {
        color: #e1456e;
        font-weight: 500;
      }
      &.negative-rate {
        color: #34c759;
        font-weight: 500;
      }
    }
  }

  .name-column {
    width: 130px;
    position: relative;
    display: flex;
    align-items: center;
  }

  .stock-code {
    font-size: 15px;
    line-height: 1.5;
    font-weight: 500;
    color: #333;
  }

  .transaction-type {
    display: inline-block;
    font-size: 14px;
    padding: 2px 8px;
    background: #f1f2f3;
    border-radius: 4px;
    text-align: center;
    margin-left: 6px;

    &.buy {
      color: #ff0000;
      background: #ff000010;
    }

    &.sell {
      color: #0067cf;
      background: #0067cf10;
    }
  }

  .date {
    font-size: 12px;
    color: #999;
    margin-top: 4px;
    position: absolute;
    bottom: -16px;
    left: 0;
  }

  .buy-price-column {
    flex: 1;
    font-weight: 500;
    color: #333;
    font-size: 16px;
    text-align: center;
  }

  .sell-price-column {
    flex: 1;
    font-weight: 500;
    color: #333;
    font-size: 16px;
    text-align: center;
  }

  .return-rate {
    max-width: 76px;
    min-width: 66px;
    text-align: right;
    font-weight: 500;
    font-size: 18px;

    &.positive {
      color: #e1456e;
    }

    &.negative {
      color: #67c23a;
    }
  }

  // 卡片内容样式
  .right-text {
    color: #ff6600;
    font-weight: 500;
  }

  .mid {
    background-color: #f5f5f5;
    min-height: 100vh;
    padding-bottom: 80px;
  }

  .date-range-picker {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 16px 0;
  }

  .date-input {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

    span {
      font-size: 14px;
      color: #333;
    }
  }

  .dropdown-icon {
    width: 16px;
    height: 16px;
    margin-left: 4px;
  }

  .date-separator {
    margin: 0 12px;
    font-size: 14px;
    color: #666;
  }

  .collapse-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .stock-name {
    font-weight: 500;
    font-size: 16px;
    color: #333;
  }

  .collapse-content {
    padding: 12px 0;
  }

  .info-row {
    display: flex;
    margin-bottom: 8px;
    line-height: 1.5;
  }

  .info-label {
    color: #666;
    min-width: 120px;
  }

  .info-value {
    color: #333;
    font-weight: 500;
  }

  .custom-collapse {
    margin: 0 16px;
  }

  .bottom {
    bottom: 0;
    height: 50px;
    position: fixed;
    width: 100%;
    z-index: 999;
  }

  .image-contain {
    background: #fff;
    margin-right: 8px;
    width: 150px;
    height: 156px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;

    .image-inner {
      display: block;
      width: 140px;
      height: 140px;
      object-fit: cover;
    }
  }

  .notice-bar-wrap {
    height: 110px;
    margin-top: 12px;
    margin-left: 16px;
    //margin-bottom: 10px;
    overflow: hidden;

    .notice-bar {
      background-color: #edeff3;
      padding: 8px 16px;
      border-radius: 30px;
      min-width: 217px;
      max-width: max-content;
      display: flex;
      align-items: center;
      justify-content: center;

      .notice-icon {
        margin-right: 6px;
        margin-left: -8px;
        //margin-top: -20%;
        display: block;
        width: 16px;
        height: 16px;
      }

      .text {
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 350;
        line-height: normal;

        strong {
          font-weight: 600;
        }
      }
    }
  }

  .user-introduce {
    margin-bottom: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    letter-spacing: 0px;
    color: #00000099;
    padding: 0 16px;
    word-break: break-all;
    white-space: normal;
    height: auto;
    width: 100%;
  }

  /* 三行文本截断 */
  .line-clamp-3 {
    max-height: 4.5em;
    overflow: hidden;
  }

  .section-desc {
    margin-top: 14px;
    background: #f7f7f8;
    padding: 12px;
    border-radius: 8px;

    .desc-title {
      color: #000;
      font-size: 16px;
      font-weight: 600;
      font-family: PingFangSC-Medium;
    }

    .desc-content {
      margin-top: 8px;
      color: rgba(0, 0, 0, 0.6);
      font-size: 12px;
      line-height: 1.5;
      font-weight: 400;
      text-align: justify;
      max-height: 60px;
      overflow: hidden;
      position: relative;
      transition: max-height 0.3s ease;
      cursor: pointer;

      &.expanded {
        max-height: none;
        overflow: visible;
      }

      &:not(.expanded)::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 24px;
        background: linear-gradient(
          to bottom,
          rgba(247, 247, 248, 0),
          rgba(247, 247, 248, 1)
        );
        pointer-events: none;
      }
    }

    .expand-trade {
      text-align: center;
      font-size: 14px;
      color: #666;
      cursor: pointer;
      padding: 12px 0 0;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;
      margin-top: 4px;

      .dropdown-icon {
        width: 14px;
        height: 14px;
        margin-left: 4px;
        transition: transform 0.3s;

        &.rotate-icon {
          transform: rotate(180deg);
        }
      }
    }
  }

  .transaction-header {
    display: flex;
    padding: 12px 0;
    border-bottom: 1px solid #eeeeee;
    color: #999999;
    font-size: 14px;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 10;
  }

  .header-item {
    &.name-time {
      width: 130px;
    }

    &.buy-price {
      flex: 1;
      text-align: center;
    }

    &.sell-price {
      flex: 1;
      text-align: center;
    }

    &.return-rate-header {
      width: 80px;
      text-align: right;
    }
  }

  // AI实况样式
  .ai-dynamic {
    margin-top: 24px;
    .chart-title-bar {
      margin-bottom: 12px;
      .ai-dynamic-title {
        margin-left: 0;
      }
    }
  }

  .ai-live-section {
    margin: 0 16px 24px;
    padding: 16px;
    background-color: #fff;
    border-radius: 12px;
    max-height: 65vh;
    overflow-y: scroll;
  }

  .ai-live-date {
    margin-right: 16px;
    .current-date {
      font-size: 14px;
      color: #8e8e93;
    }
  }

  .ai-live-list {
    position: relative;
    transition: all 0.3s ease;
  }

  .ai-live-list:before {
    content: "";
    position: absolute;
    width: 2px;
    top: 8px;
    bottom: 8px;
    left: 74px; /* 调整为时间列宽度 */
    background-color: #e0e0e0;
  }

  .ai-live-item {
    display: flex;
    margin-bottom: 12px;
    position: relative;
    transition: all 0.3s ease;
    animation: fadeIn 0.3s ease-in-out;

    &:last-child {
      margin-bottom: 16px;
    }

    &:before {
      content: "";
      position: absolute;
      width: 12px;
      height: 12px;
      background-color: #d9d9d9;
      border-radius: 50%;
      left: 69px; /* 调整为时间列宽度减去圆点半径 */
      top: 6px;
      z-index: 1;
      box-sizing: border-box;
      transition: background-color 0.3s ease;
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .ai-live-time-column {
    flex-shrink: 0;
    padding-right: 20px; /* 增加右侧padding，为时间轴留出空间 */
    text-align: right;
    font-size: 13px;
    color: #00000099;
    position: relative;
    top: 4px;

    .ai-date {
      line-height: 1.3;
    }

    .ai-time {
      margin-top: 2px;
    }
  }

  .ai-live-content {
    flex: 1;
    margin-left: 18px; /* 内容与时间轴的间距 */
    position: relative;

    .ai-live-title {
      position: relative;
      top: 2px;
      font-size: 14px;
      font-weight: 500;
      color: #000;
      line-height: 1.5;
      margin-bottom: 4px;
    }

    .ai-live-desc {
      font-size: 13px;
      line-height: 1.5;
      color: #666;
      margin-bottom: 8px;
      text-align: justify;
      display: block;
      // 富文本内容含多个块级子元素时 -webkit-line-clamp 在 iOS WebKit 上会叠字
      max-height: 4.5em;
      overflow: hidden;
      position: relative;
      width: 100%;
      box-sizing: border-box;
      word-break: break-all;

      &.expanded {
        max-height: none;
      }

      &::after {
        content: "更多";
        position: absolute;
        right: 0;
        bottom: 0;
        padding-left: 36px;
        background: linear-gradient(to right, rgba(255, 255, 255, 0), #fff 40%);
        font-weight: 600;
        font-size: 13px;
        color: #00000099;
        cursor: pointer;
        display: none;
        line-height: 1.5;
      }

      &:not(.expanded)::after {
        display: inline;
      }

      &.expanded::after {
        display: none;
      }

      &.no-ellipsis::after {
        display: none;
      }
    }

    .collapse-button {
      text-align: center;
      font-size: 13px;
      color: #00000099;
      cursor: pointer;
      padding: 8px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;
      margin-top: 4px;

      .dropdown-icon {
        width: 12px;
        height: 12px;
        margin-left: 4px;
        transition: transform 0.3s;

        &.rotate-icon {
          transform: rotate(180deg);
        }
      }

      &:hover {
        color: #000;
      }
    }
  }

  .expand-all {
    text-align: center;
    font-size: 14px;
    color: #666;
    cursor: pointer;
    padding: 12px 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    position: relative;
    top: -20px;

    .dropdown-icon {
      width: 14px;
      height: 14px;
      margin-left: 4px;
      transition: transform 0.3s;

      &.rotate-icon {
        transform: rotate(180deg);
      }
    }
  }
}
</style>
<style lang="less">
// AI实况正文由 v-html 注入，子元素带不上 scoped 属性，故样式写在非 scoped 块内
.ai-live-desc {
  p,
  ul,
  ol,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  blockquote {
    margin: 0 0 6px;
    font-size: inherit;
    line-height: inherit;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 600;
  }

  ul,
  ol {
    padding-left: 18px;
  }

  > *:last-child {
    margin-bottom: 0;
  }

  // 收起态清零块间距，让三行截断落在整行边界上
  &:not(.expanded) {
    p,
    ul,
    ol,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    blockquote {
      margin-bottom: 0;
    }
  }
}

.markdown-content {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 16px;
    font-weight: 600;
    line-height: 1.25;
  }

  h1 {
    font-size: 16px;
  }

  h2 {
    font-size: 15px;
  }

  h3,
  h4,
  h5,
  h6 {
    font-size: 14px;
  }

  p {
    margin-top: 0;
  }

  ul,
  ol {
    padding-left: 12px;
    margin-left: 8px;
    list-style-position: outside;
  }

  ul > li {
    list-style-type: disc;
  }

  ol > li {
    list-style-type: decimal;
  }

  li {
    line-height: 1.4;

    & > ul,
    & > ol {
      margin-top: 6px;
    }
  }

  li:last-child {
    margin-bottom: 0;
  }

  a {
    color: #0061c9;
    text-decoration: none;
  }

  code {
    font-family: monospace;
    background-color: rgba(0, 0, 0, 0.05);
    padding: 2px 4px;
    border-radius: 3px;
    font-size: 12px;
  }

  pre {
    background-color: rgba(0, 0, 0, 0.05);
    padding: 12px;
    border-radius: 5px;
    overflow-x: auto;

    code {
      background-color: transparent;
      padding: 0;
    }
  }

  blockquote {
    margin-left: 0;
    padding-left: 8px;
    border-left: 4px solid #ddd;
    color: #666;
  }

  table {
    border-collapse: collapse;
    width: 100%;

    th,
    td {
      border: 1px solid #ddd;
      padding: 6px 8px;
      text-align: left;
    }

    th {
      background-color: rgba(0, 0, 0, 0.05);
    }
  }

  img {
    max-width: 100%;
    height: auto;
    border-radius: 4px;
  }
}
</style>
